import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { buildDashboardHeaderQuickActions } from "./platformDashboardCapabilities.utils";

const PlatformDashboardQuickActions = ({ capabilities = {}, profile }) => {
  const actions = useMemo(
    () => buildDashboardHeaderQuickActions(capabilities, profile),
    [capabilities, profile]
  );

  if (actions.length === 0) {
    return null;
  }

  return (
    <section className="mb-4 rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
      <h2 className="text-sm font-semibold text-gray-900">Quick actions</h2>
      <div className="mt-3 flex flex-wrap gap-2">
        {actions.map((action) => (
          <Link
            key={action.id}
            to={action.to}
            className="rounded-full bg-gray-100 px-3 py-1.5 text-xs font-medium text-gray-700 transition hover:bg-indigo-100 hover:text-indigo-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
          >
            {action.label}
          </Link>
        ))}
      </div>
    </section>
  );
};

export default PlatformDashboardQuickActions;
